import { useContext } from "react";
import { NavbarContext } from "../contexts/navbarContext";

export const useNavbarContext = () => {
  const context = useContext(NavbarContext);

  if (!context) {
    throw new Error(
      "useNavbarContext must be used within a NavbarProvider"
    );
  }

  return context;
};

